import { AcceptTermsCheckbox, FilteredCreditApplication, PageSectionTitle as SectionTitle, UnderReviewTile } from '@applyonline/shared'
import { ECreditApplicationStep } from '@if/core/types'
import { FormEvent, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import UploadFilesTable from '../../../../components/UploadFilesTable'
import { hasMissingDocuments } from '../../../../data/creditapp-selectors'

interface Props {
  creditApp: FilteredCreditApplication
}
const FailedToObtainCreditReportForm = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const [showUploadFile, setShowUpload] = useState(false)
  const hasMissingDocs = hasMissingDocuments(creditApp, ECreditApplicationStep.Credit)

  const toggleUploadFile = (e: FormEvent) => {
    e.preventDefault()
    setShowUpload(true)
  }

  return (
    <main className="general-message" style={{ paddingTop: 0 }}>
      {!showUploadFile && hasMissingDocs && (
        <form onSubmit={toggleUploadFile}>
          <SectionTitle title={t('common.financeApplication')} />
          <h1>{t('identity.cannotConfirm')}</h1>
          <div className="paragraph">
            <p>
              <Trans i18nKey="identity.hereToHelp" />
            </p>
            <p>{t('identity.notifyEmail')}</p>
            <p>{t('identity.consent')}</p>
            <AcceptTermsCheckbox
              id="acceptConditions"
              termId={t('identity.byClicking')}
              msgOnInvalid={t('common.acceptConditions')}
            />
          </div>
          <div style={{ textAlign: 'center' }}>
            <button type="submit" className="btn btn-blue">
              <span>{t('common.submit')}</span>
              <i className="fa-regular fa-arrow-right" />
            </button>
          </div>
        </form>
      )}
      {showUploadFile && hasMissingDocs && <UploadFilesTable creditApp={creditApp} />}
      {!hasMissingDocs && <UnderReviewTile />}
    </main>
  )
}

export default FailedToObtainCreditReportForm
